import React, { createContext, useCallback, useContext, useState } from 'react';

const CURRENCY_KEY = 'currency';
const DEFAULT_CURRENCY = '$';

const CurrencyContext = createContext(null);

export const CurrencyProvider = ({ children }) => {
    const [currency, setCurrencyState] = useState(() => {
        const stored = localStorage.getItem(CURRENCY_KEY);
        return stored !== null ? stored : DEFAULT_CURRENCY;
    });

    const setCurrency = useCallback((symbol) => {
        localStorage.setItem(CURRENCY_KEY, symbol);
        setCurrencyState(symbol);
    }, []);

    return (
        <CurrencyContext.Provider value={{ currency, setCurrency }}>
            {children}
        </CurrencyContext.Provider>
    );
};

export const useCurrency = () => {
    const ctx = useContext(CurrencyContext);
    if (!ctx) throw new Error('useCurrency must be used within a CurrencyProvider');
    return ctx;
};
